/** Pure helpers + types for PipelineActivityTab. No React — keeps
 *  fast-refresh happy when imported by component files.
 */
import type { PausedStage } from '@/types/enums';

export interface PausedJob {
  id: string;
  file_name: string | null;
  review_status: string;
  updated_at: string;
  created_at: string;
  status: string;
  /** Backend marks cancelled-but-resumable jobs with this flag. The
   *  FE renders them with a distinct "Recall" CTA. */
  recallable?: boolean;
}

export function relativeTime(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60_000) return 'just now';
  if (ms < 3_600_000) return `${Math.floor(ms / 60_000)}m ago`;
  if (ms < 86_400_000) return `${Math.floor(ms / 3_600_000)}h ago`;
  return `${Math.floor(ms / 86_400_000)}d ago`;
}

export function pausedAt(reviewStatus: string): PausedStage | null {
  if (!reviewStatus.startsWith('paused_at_')) return null;
  return reviewStatus.slice('paused_at_'.length) as PausedStage;
}
